import { createAppSelector } from 'store/hooks';

export const confirmActionModalSelector = createAppSelector(
  [
    (state) => state.modal.confirmAction.cancelTitle,
    (state) => state.modal.confirmAction.confirmTitle,
    (state) => state.modal.confirmAction.description,
    (state) => state.modal.confirmAction.modalType,
    (state) => state.modal.confirmAction.taskId,
    (state) => state.modal.confirmAction.children,
    (state) => state.focusMode.currentViewedFocusTemplate,
    (state) => state.focusMode.isFocusTemplateDeleting,
    (state) => state.habitPack.currentViewedPack,
    (state) => state.habitPack.isHabitPacksDeleting,
    (state) => state.habitPack.isUserUpsertingPack,
    (state) => state.setting.areSettingsSaving,
    (state) => state.modal.deleteKeywordModal,
    (state) => state.toDo.player.tasks,
    (state) => state.modal.confirmAction.data,
    (state) => state.toDo.player.selectedTask,
    (state) => state.user.auth0User?.email,
    (state) => state.toDo.selectedTaskToTaskForm,
    (state) => state.toDo.isDeletingTask,
    (state) => state.note.isDeletingNote
  ],
  (
    cancelTitle,
    confirmTitle,
    description,
    modalType,
    taskId,
    children,
    currentViewedFocusTemplate,
    isFocusTemplateDeleting,
    currentViewedPack,
    isHabitPacksDeleting,
    isUserUpsertingPack,
    areSettingsSaving,
    deleteKeywordModal,
    playerTasks,
    data,
    playerSelectedTask,
    userEmail,
    selectedTaskToTaskForm,
    isDeletingTask,
    isDeletingNote
  ) => {
    return {
      cancelTitle,
      confirmTitle,
      description,
      modalType,
      taskId,
      children,
      currentViewedFocusTemplate,
      isFocusTemplateDeleting,
      currentViewedPack,
      isHabitPacksDeleting,
      isUserUpsertingPack,
      areSettingsSaving,
      deleteKeywordModal,
      playerTasks,
      data,
      playerSelectedTask,
      userEmail,
      selectedTaskToTaskForm,
      isDeletingTask,
      isDeletingNote
    };
  }
);
